import config from '../../../../config';
import {getMemberRole, getPermissions, getUserClients} from '../../../../utils/General';
import {subMenuManagement} from '../../../../utils/Constans';
import ForumIcon from '../../../../assets/icons/ForumIcon';
import MySpaceIcon from '../../../../assets/icons/nav/MySpaceIcon';
import InternalChatsIcon from '../../../../assets/icons/nav/InternalChatsIcon';

/*
 * The row of links at the foot of the landing page.
 *
 * Every entry here is a place the sidebar can also lead to, and every one of
 * them is conditional - on the tariff, on a feature, on a role, and in one case
 * on whether the operator is attached to any bot at all. Writing those tests out
 * a second time is what put a Chats button in front of an operator who has no
 * chats: the sidebar knew to hide it and this page did not.
 *
 * So the management entries are read out of subMenuManagement, the same list the
 * sidebar builds itself from, and the three chat entries are written once here
 * rather than once per dashboard.
 */
export function buildHomeLinks(user, company) {
    const {tariff} = company;
    const {features} = tariff;

    const isActiveTariff = [
        config.tariffStatusMap.active,
        config.tariffStatusMap.trial
    ].indexOf(tariff.status) !== -1;

    if (!isActiveTariff) return [];

    const permissions = getPermissions(user);
    const isManager = permissions.indexOf(config.permissions.management) !== -1;
    const clients = getUserClients(user, company);
    const role = getMemberRole(user).id;

    const links = [];

    // an operator attached to no bot has nothing in here, which is why the
    // sidebar leaves this out for them
    if (clients.length || isManager) {
        links.push({key: 'all-chats', path: '/dashboard/chat/all', label: 'all-chats', icon: ForumIcon});
    }

    if (features.includes(config.features.INTERNAL_CHATS)) {
        links.push({
            key: 'internal',
            path: '/dashboard/chat/' + config.platformsMap.company,
            label: 'MembersChat',
            icon: InternalChatsIcon,
        });
    }

    if (features.includes(config.features.MY_HISTORY) || features.includes(config.features.TICKETS)) {
        links.push({key: 'my-space', path: '/dashboard/my/space', label: 'My Space', icon: MySpaceIcon});
    }

    if (isManager) {
        subMenuManagement
            .filter(item => item.permissions.indexOf(role) !== -1)
            .filter(item => !item.features || features.includes(item.features[0]))
            .forEach(item => links.push({
                key: item.id,
                path: item.path,
                label: item.translateKey,
                icon: item.icon,
            }));
    }

    return links;
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/home/links.js